const ANONYMOUS_LD_STORAGE_KEY = 'bennie-ld-anonymous-context-key';

const createEphemeralAnonymousKey = () => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

/**
 * Anonymous LaunchDarkly user context for SDK 3.x (requires kind, key, and anonymous).
 * Reuses one key per tab session when sessionStorage is available.
 */
export const getAnonymousLaunchDarklyUserContext = () => {
  let key;
  try {
    key = sessionStorage.getItem(ANONYMOUS_LD_STORAGE_KEY);
    if (!key) {
      key = createEphemeralAnonymousKey();
      sessionStorage.setItem(ANONYMOUS_LD_STORAGE_KEY, key);
    }
  } catch {
    key = createEphemeralAnonymousKey();
  }

  return {
    kind: 'user',
    key,
    anonymous: true,
  };
};
